import React from "react"
import { createContext } from "use-context-selector"
// direct import (not the @hooks barrel): useHistoricalExecutionNotice in @hooks imports this context
import useAppContextState from "app/@hooks/useContextState"

// Selected report execution of the Analyzer headers (Competition / Parity / Packages).
// isHistorical: older than the ClickHouse retention, its data is read from BigQuery (header "Historical data" badge).
const Context = createContext({})

const initialState = {
    isHistorical: false,
}

export function AppReportExecutionProvider({ children }) {
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, replaceState, resetState, updateState }}>
        {children}
    </Context.Provider>
}
export default Context
